import { useState, useRef, useMemo } from 'react';
import { canInsertList as validateCanInsertList, detectSelectedListType, } from '../../util/notes';
export const useInitializeListButtonsContext = () => {
    const [selectedListType, setSelectedListType] = useState();
    const [canInsertList, setCanInsertList] = useState(true);
    const selectionForLists = useRef((ctx, selection) => {
        const listType = detectSelectedListType(ctx, selection);
        setSelectedListType(listType);
        setCanInsertList(validateCanInsertList(selection));
    });
    const contextValue = useMemo(() => ({
        selectionForLists: selectionForLists.current,
        selectedListType,
        canInsertList,
    }), [canInsertList, selectedListType]);
    return contextValue;
};
//# sourceMappingURL=use_initialize_list_buttons_context.js.map